import { z } from 'zod'

// ISO 8601 形式（Z または +HH:MM オフセット付き）のみ受け付ける
export const DateTimeStringSchema = z.iso.datetime({ offset: true })

export const CommonHeadersSchema = z.object({
  'x-local': z.string().optional(),
  'x-raund-campaign': z.string(),
  'x-raund-token': z.string(),
  'x-raund-client-id': z.string().uuid().describe('デバイス固有ID（フロントエンドが localStorage に保存した UUID v4）'),
})

export const IdPathParamsSchema = z.object({
  id: z.number(),
})

export const StampQuizPathParamsSchema = z.object({
  stampId: z.number(),
  quizId: z.number(),
})

export type DateTimeString = z.infer<typeof DateTimeStringSchema>
export type CommonHeaders = z.infer<typeof CommonHeadersSchema>
export type IdPathParams = z.infer<typeof IdPathParamsSchema>
export type StampQuizPathParams = z.infer<typeof StampQuizPathParamsSchema>
